import request from '../utils/request'
import axios from 'axios'

export function adminLogin(data) {
  return request.post('/api/admin/auth/login', data)
}

export function changeAdminPassword(data) {
  return request.post('/api/admin/auth/change-password', data)
}

export function getCategoryList() {
  return request.get('/api/admin/category/list')
}

export function addCategory(data) {
  return request.post('/api/admin/category/add', data)
}

export function getBannerList() {
  return request.get('/api/admin/banner/list')
}

export function getBannerDetail(id) {
  return request.get(`/api/admin/banner/detail/${id}`)
}

export function addBanner(data) {
  return request.post('/api/admin/banner/add', data)
}

export function updateBanner(data) {
  return request.post('/api/admin/banner/update', data)
}

export function deleteBanner(id) {
  return request.post(`/api/admin/banner/delete/${id}`)
}

export function upBanner(id) {
  return request.post(`/api/admin/banner/up/${id}`)
}

export function downBanner(id) {
  return request.post(`/api/admin/banner/down/${id}`)
}

export function getHomeNavList() {
  return request.get('/api/admin/home-nav/list')
}

export function getHomeNavDetail(id) {
  return request.get(`/api/admin/home-nav/detail/${id}`)
}

export function addHomeNav(data) {
  return request.post('/api/admin/home-nav/add', data)
}

export function updateHomeNav(data) {
  return request.post('/api/admin/home-nav/update', data)
}

export function deleteHomeNav(id) {
  return request.post(`/api/admin/home-nav/delete/${id}`)
}

export function upHomeNav(id) {
  return request.post(`/api/admin/home-nav/up/${id}`)
}

export function downHomeNav(id) {
  return request.post(`/api/admin/home-nav/down/${id}`)
}

export function updateCategory(data) {
  return request.post('/api/admin/category/update', data)
}

export function deleteCategory(id) {
  return request.post(`/api/admin/category/delete/${id}`)
}

export function getProductPage(params) {
  return request.get('/api/admin/product/page', { params })
}

export function getProductDetail(id) {
  return request.get(`/api/admin/product/detail/${id}`)
}

export function addProduct(data) {
  return request.post('/api/admin/product/add', data)
}

export function updateProduct(data) {
  return request.post('/api/admin/product/update', data)
}

export function uploadAdminImage(file) {
  return uploadAdminImageToQiniu(file).catch(() => uploadAdminImageToLocal(file))
}

export function getQiniuUploadToken() {
  return request.get('/api/admin/upload/qiniu-token')
}

export function getQiniuUploadTokenByKey(key) {
  return request.get('/api/admin/upload/qiniu-token', { params: { key } })
}

async function uploadAdminImageToQiniu(file) {
  const baseConfig = await getQiniuUploadToken()
  if (!baseConfig || !baseConfig.enabled) {
    return Promise.reject(new Error('七牛云上传未启用'))
  }
  const key = buildQiniuKey(file, baseConfig.prefix)
  const config = await getQiniuUploadTokenByKey(key)
  if (!config || !config.enabled) {
    return Promise.reject(new Error('七牛云上传未启用'))
  }
  const uploadKey = config.key || key
  const formData = new FormData()
  formData.append('token', config.token)
  formData.append('key', uploadKey)
  formData.append('file', file)
  const response = await axios.post(config.uploadHost, formData, {
    timeout: 30000
  })
  const fileKey = response.data && response.data.key ? response.data.key : uploadKey
  return {
    url: `${normalizeDomain(config.domain)}/${fileKey}`,
    fileName: fileKey.split('/').pop(),
    originalName: file.name || fileKey
  }
}

function uploadAdminImageToLocal(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request.post('/api/admin/upload/image', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

function buildQiniuKey(file, prefix = 'mall/images/') {
  const safePrefix = normalizePrefix(prefix)
  const now = new Date()
  const year = now.getFullYear()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  const extension = getFileExtension(file && file.name)
  return `${safePrefix}${year}${month}${day}/${Date.now()}_${randomText()}${extension}`
}

function getFileExtension(fileName = '') {
  const matched = String(fileName).toLowerCase().match(/\.([a-z0-9]+)$/)
  return matched ? `.${matched[1]}` : '.jpg'
}

function randomText() {
  return Math.random().toString(36).slice(2, 10)
}

function normalizePrefix(prefix = '') {
  let normalized = prefix || 'mall/images/'
  if (normalized.startsWith('/')) normalized = normalized.slice(1)
  return normalized.endsWith('/') ? normalized : `${normalized}/`
}

function normalizeDomain(domain = '') {
  return domain.endsWith('/') ? domain.slice(0, -1) : domain
}

export function upProduct(id) {
  return request.post(`/api/admin/product/up/${id}`)
}

export function downProduct(id) {
  return request.post(`/api/admin/product/down/${id}`)
}

export function deleteProduct(id) {
  return request.post(`/api/admin/product/delete/${id}`)
}

export function getOrderPage(params) {
  return request.get('/api/admin/order/page', { params })
}

export function getOrderDetail(orderNo) {
  return request.get(`/api/admin/order/detail/${orderNo}`)
}

export function deliveryOrder(data) {
  return request.post('/api/admin/order/delivery', data)
}

export function handleOrderAfterSale(orderNo, data) {
  return request.post(`/api/admin/order/after-sale/${orderNo}`, data)
}

export function createOrderRefund(orderNo, data) {
  return request.post(`/api/admin/order/refund/create/${orderNo}`, data)
}

export function processOrderRefund(id) {
  return request.post(`/api/admin/order/refund/process/${id}`)
}

export function markOrderRefundSuccess(id, params) {
  return request.post(`/api/admin/order/refund/success/${id}`, null, { params })
}

export function markOrderRefundFail(id, params) {
  return request.post(`/api/admin/order/refund/fail/${id}`, null, { params })
}

export function getOrderConfig() {
  return request.get('/api/admin/order-config/detail')
}

export function saveOrderConfig(data) {
  return request.post('/api/admin/order-config/save', data)
}

export function getGroupBuyStats() {
  return request.get('/api/admin/group-buy/stats')
}

export function getGroupBuyActivityPage(params) {
  return request.get('/api/admin/group-buy/activity/page', { params })
}

export function getGroupBuyRecordPage(params) {
  return request.get('/api/admin/group-buy/record/page', { params })
}

export function getRefundRecordPage(params) {
  return request.get('/api/admin/group-buy/refund/page', { params })
}

export function processRefundRecord(id) {
  return request.post(`/api/admin/group-buy/refund/process/${id}`)
}

export function markRefundSuccess(id, params) {
  return request.post(`/api/admin/group-buy/refund/success/${id}`, null, { params })
}

export function markRefundFail(id, params) {
  return request.post(`/api/admin/group-buy/refund/fail/${id}`, null, { params })
}

export function upGroupBuyActivity(id) {
  return request.post(`/api/admin/group-buy/up/${id}`)
}

export function downGroupBuyActivity(id) {
  return request.post(`/api/admin/group-buy/down/${id}`)
}

export function closeGroupBuyRecord(id) {
  return request.post(`/api/admin/group-buy/record/close/${id}`)
}

export function failGroupBuyRecord(id) {
  return request.post(`/api/admin/group-buy/record/fail/${id}`)
}

export function completeGroupBuyRecord(id) {
  return request.post(`/api/admin/group-buy/record/complete/${id}`)
}

export function fillSuccessGroupBuyRecord(id) {
  return request.post(`/api/admin/group-buy/record/fill-success/${id}`)
}

export function updateGroupBuyRecordAppDisplay(id, appDisplay) {
  return request.post(`/api/admin/group-buy/record/app-display/${id}`, null, {
    params: { appDisplay }
  })
}

export function createPlatformGroupBuyRecord(params) {
  return request.post('/api/admin/group-buy/record/platform-create', null, { params })
}

export function closeExpiredGroupBuy() {
  return request.post('/api/admin/group-buy/close-expired')
}

export function getProfileStyle() {
  return request.get('/api/admin/profile-style/detail')
}

export function saveProfileStyle(data) {
  return request.post('/api/admin/profile-style/save', data)
}

export function getStoreConfig() {
  return request.get('/api/admin/store-config/detail')
}

export function saveStoreConfig(data) {
  return request.post('/api/admin/store-config/save', data)
}

export function getShareRewardConfig() {
  return request.get('/api/admin/share-reward/config')
}

export function saveShareRewardConfig(data) {
  return request.post('/api/admin/share-reward/config', data)
}

export function getShareRewardRecords(params) {
  return request.get('/api/admin/share-reward/records', { params })
}

export function getPointProductPage(params) {
  return request.get('/api/admin/point-mall/product/page', { params })
}

export function getPointProductDetail(id) {
  return request.get(`/api/admin/point-mall/product/detail/${id}`)
}

export function addPointProduct(data) {
  return request.post('/api/admin/point-mall/product/add', data)
}

export function updatePointProduct(data) {
  return request.post('/api/admin/point-mall/product/update', data)
}

export function upPointProduct(id) {
  return request.post(`/api/admin/point-mall/product/up/${id}`)
}

export function downPointProduct(id) {
  return request.post(`/api/admin/point-mall/product/down/${id}`)
}

export function deletePointProduct(id) {
  return request.post(`/api/admin/point-mall/product/delete/${id}`)
}

export function getPointOrderPage(params) {
  return request.get('/api/admin/point-mall/order/page', { params })
}

export function getPointOrderDetail(orderNo) {
  return request.get(`/api/admin/point-mall/order/detail/${orderNo}`)
}

export function deliveryPointOrder(data) {
  return request.post('/api/admin/point-mall/order/delivery', data)
}
